import { AutoCompleteMultiple } from '@elotech/components';
import { CustomLinkExternal, Label } from 'common/components';
import { UNCPessoa } from 'common/type';
import { formataCpfOuCnpj, getUrl } from 'common/utils';
import { FC } from 'react';

import { PessoaSearchPropsBase } from './PessoaSearch';

export type PessoaSearchPropsMultiple = PessoaSearchPropsBase & {
  value: any[];
  onSelect: (name: string, values?: UNCPessoa[]) => void;
};

export const PessoaSearchMultiple: FC<PessoaSearchPropsMultiple> = ({
  name,
  value,
  error,
  onSelect,
  onSearch,
  onCreateValue,
  noLabel = false,
  label = 'Pessoas',
  disabled = false
}) => {
  return (
    <>
      {!noLabel && <Label>{label}</Label>}
      <AutoCompleteMultiple<UNCPessoa>
        values={value || []}
        name={name}
        onClear={() => onSelect(name, [])}
        onRemoveItem={(_, values) => onSelect(name, values)}
        showOptionsBottom
        autoFocus={false}
        onSelect={(name, _, values) => onSelect(name, values)}
        isDisabled={disabled}
        className={!!error ? 'error' : ''}
        getOptionValue={pessoa => pessoa.id}
        getOptionLabel={(pessoa: UNCPessoa) =>
          pessoa
            ? `${pessoa.nome} - ${formataCpfOuCnpj(pessoa.cnpjCpf!)}`
            : 'Nova pessoa'
        }
        onSearch={onSearch}
        onCreateValue={onCreateValue}
        getDetailOptionLabel={pessoa => (
          <>
            {`${pessoa?.nome} - ${formataCpfOuCnpj(pessoa?.cnpjCpf!)}`}
            <CustomLinkExternal
              forceRight
              identificador={''}
              uri={getUrl('unico', `/pessoas/${pessoa?.id!}`)}
            />
          </>
        )}
        newValueLabel="Incluir pessoa"
      />
      {!!error && <span className="help-message">{error}</span>}
    </>
  );
};
